var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, css } from 'lit';
import { PICBarChart } from '../Draw/PICBarChart';
import { customElement, PICBase, fetchApiData, } from '../Internals';
let PICMobileMon = class PICMobileMon extends PICBase {
    static get styles() {
        const defaultStyle = css `
        
        .graphContainer {
            border: 1px solid gray;
            border-radius: 16px;
            margin: 4px;
            box-shadow: 5px 5px 19px 0px rgba(0,0,0,0.75);
            -webkit-box-shadow: 5px 5px 19px 0px rgba(0,0,0,0.75);
            -moz-box-shadow: 5px 5px 19px 0px rgba(0,0,0,0.75);
        }

        .graphContainer > .inner {
            display: inline-flex;
            margin: 4px;
        }

        .graphContainerHdr {
            border-bottom: 1px solid gray;
            text-align: center;
            background-color: var(--pic-primaryColor);
            color: white;
            border-radius: 16px 16px 0 0;
        }

        .barChartContainer, .d3 {
            display: inline-flex;
            border: 1px solid lightgray;
            border-radius: 16px;
            margin: 4px;
            padding: 1rem;
        }

        .graphGrp{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }

        .hidden{
            display: none;
        }

        `;
        return css `
      ${super.styles}
      ${defaultStyle}
    `;
    }
    constructor() {
        super();
    }
    connectedCallback() {
        super.connectedCallback();
        this.getDataFromAPIs();
    }
    doURI(front, back) {
        let arr = location.hostname.split('.');
        arr[0] = front;
        return `${location.protocol}//${arr.join('.')}${back ? '/' + back : ''}`;
    }
    getDataFromAPIs() {
        let serverList = [{ url: this.doURI('login1', 'api/json'), systemId: 'lo1' },
            { url: this.doURI('login2', 'api/json'), systemId: 'lo2' },
            { url: this.doURI('login3', 'api/json'), systemId: 'lo3' }];
        serverList.forEach(x => this.getDataFromAPI(x.systemId, x.url));
    }
    getDataFromAPI(systemId, url) {
        console.log('Getting data from server: ' + systemId);
        let options = {
            url: url ? url : this.doURI('api', 'json'),
            sessionId: 'a2pZYUVkaGN2UWpkcGJrTzpmc2ViYmJkY3VFaGF5YWR3',
            systemId: systemId,
            postBody: {},
        };
        fetchApiData('/test/mobilemon', options)
            .then((data) => {
            var _a;
            if (data.devices) {
                this.data = data.devices;
                this.doCharts(systemId);
                let graphContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#graphContainer' + systemId);
                graphContainer.classList.toggle('hidden');
            }
        })
            .catch((err) => console.log(err));
    }
    doCharts(systemId) {
        //By device type
        // console.log('device metrics', this.data.deviceMetrics[0]);
        // this.renderBarChart(systemId, this.data.deviceMetrics[0], "Logins by device type");
        //By version
        let droids = this.data.deviceInfo.filter(device => device.systemOs.toLowerCase() == 'android');
        droids.sort((a, b) => (a.osVersion > b.osVersion) ? 1 : -1);
        let mapped = new Map();
        let maxCount = 0;
        droids.forEach(d => {
            if (mapped.has(d.osVersion)) {
                let curObj = mapped.get(d.osVersion);
                curObj.count++;
                curObj.fromDate = curObj.fromDate > d.logDate ? d.logDate : curObj.fromDate;
                curObj.toDate = curObj.fromDate < d.logDate ? d.logDate : curObj.toDate;
            }
            else {
                mapped.set(d.osVersion, { count: 0, fromDate: d.logDate, toDate: d.logDate });
            }
        });
        let droidsImLookingFor = Array.from(mapped);
        droidsImLookingFor.sort((a, b) => (Number(a[0].split('\.')[0]) > Number(b[0].split('\.')[0])) ? 1 : -1);
        let objectifiedDroids = {};
        for (let droid of droidsImLookingFor) {
            objectifiedDroids[droid[0]] = droid[1].count;
            maxCount = maxCount < droid[1].count ? droid[1].count : maxCount;
        }
        this.renderD3Barchart(systemId, droidsImLookingFor, maxCount);
        this.renderBarChart(systemId, objectifiedDroids, "Logins by android version", Math.round(maxCount / 10));
    }
    renderD3Barchart(systemId, data, iGridStep) {
        var _a;
        let d3HtmlElemnt = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#d3' + systemId);
        console.log('Drawing ' + systemId, data);
        //@ts-ignore
        let d3 = window.d3;
        // set the dimensions and margins of the graph
        let margin = { top: 30, right: 30, bottom: 70, left: 60 }, width = 460 - margin.left - margin.right, height = 400 - margin.top - margin.bottom;
        // append the svg object to the body of the page
        let svg = d3.select(d3HtmlElemnt)
            .append("svg")
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");
        // X axis
        let x = d3.scaleBand()
            .range([0, width])
            .domain(data.map(d => d[0]))
            .padding(0.2);
        svg.append("g")
            .attr("transform", "translate(0," + height + ")")
            .call(d3.axisBottom(x))
            .selectAll("text")
            .attr("transform", "translate(-10,0)rotate(-45)")
            .style("text-anchor", "end");
        // Add Y axis
        let y = d3.scaleLinear()
            .domain([0, iGridStep ? iGridStep : 200])
            .range([height, 0]);
        svg.append("g")
            .call(d3.axisLeft(y));
        var tooltip = d3.select(d3HtmlElemnt)
            .append("div")
            .attr('id', 'd3ToolTip')
            .style("position", "absolute")
            .style("z-index", "10")
            .style("visibility", "hidden")
            // .style("background", "#000")
            .text("a simple tooltip");
        let colorVar = d3.scaleLinear().domain([1, data.length]).range([this.getRandomColor(), this.getRandomColor()]);
        let cnt = 0;
        // Bars
        svg.selectAll("mybar")
            .data(data)
            .enter()
            .append("rect")
            .attr("x", (d) => { return x(d[0]); })
            .attr("y", (d) => { return y(d[1].count); })
            .attr("width", x.bandwidth())
            .attr("height", (d) => { return height - y(d[1].count); })
            .attr("fill", (d) => colorVar(cnt++))
            .attr("filter", "drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4))")
            .on("mouseover", function (d) { tooltip.text(d[1].count); return tooltip.style("visibility", "visible"); })
            .on("mousemove", function () { return tooltip.style("top", (d3.event.pageY - 10) + "px").style("left", (d3.event.pageX + 10) + "px"); })
            .on("mouseout", function () { return tooltip.style("visibility", "hidden"); });
        d3.select(d3HtmlElemnt)
            .selectAll("#d3ToolTip")
            .data(data)
            .enter().append("div")
            .style("display", "none")
            .style("width", function (d) { return x(d) + "px"; })
            .text(function (d) { return d; })
            .on("mouseover", function (d) { tooltip.text(d[1].count); return tooltip.style("visibility", "visible"); })
            .on("mousemove", function () { return tooltip.style("top", (d3.event.pageY - 10) + "px").style("left", (d3.event.pageX + 10) + "px"); })
            .on("mouseout", function () { return tooltip.style("visibility", "hidden"); });
    }
    getRandomColor() {
        return '#' + Math.floor(Math.random() * 16777215).toString(16);
    }
    renderBarChart(systemId, iData, iTitle, iGridStep) {
        var _a, _b;
        let myCanvas = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('#barchart' + systemId);
        let myLegend = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('legend[for="barchart' + systemId + '"]');
        if (myCanvas && myLegend) {
            let myBarchart = new PICBarChart({
                canvas: myCanvas,
                legend: myLegend,
                seriesName: iTitle ? iTitle : "",
                padding: 40,
                gridStep: iGridStep ? iGridStep : 200,
                gridColor: "black",
                data: iData,
                colors: ["#a55ca5", "#67b6c7", "#bccd7a", "#eb9743", "#0a734b", "#a9c089", "#b1fae4", "#1de6e3", "#0987f5"],
                titleOptions: {
                    align: "center",
                    fill: "black",
                    font: {
                        weight: "bold",
                        size: "18px",
                        family: "Lato"
                    }
                }
            });
            myBarchart.draw();
        }
    }
    loadD3Script() {
        let dt = "" + new Date().getMilliseconds();
        let script = document.createElement('script');
        if (this.onload)
            script.onload = this.onload.bind(this);
        script.src = '../scripts/picit/dbgraph/d3.v5.js';
        return script;
    }
    render() {
        let serverList = [{ name: 'Login 1', path: 'lo1' }, { name: 'Login 2', path: 'lo2' }, { name: 'Login 3', path: 'lo3' }];
        return html `
                ${this.renderCSS(true)}
                ${this.loadD3Script()}
                <div class="graphGrp">
                    ${serverList.map(x => html `
                    <div class="graphContainer hidden" id=${`graphContainer${x.path}`}>
                        <div class="graphContainerHdr pic-h6">${x.name}</div>
                        <div class="inner">
                            <div class="barChartContainer">
                                <canvas id=${`barchart${x.path}`}></canvas>
                                <legend for=${`barchart${x.path}`}></legend>
                            </div>
                            <div class="d3" id=${`d3${x.path}`}></div>
                        </div>
                    </div>
                    `)}
                </div>
        `;
    }
};
PICMobileMon = __decorate([
    customElement('pic-mobilemonitor')
], PICMobileMon);
export { PICMobileMon };
//# sourceMappingURL=PICMobileMonitor.js.map